import { NgModule } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';






import { NavbarModule } from 'app/layout/components/navbar/navbar.module';

import { ToolbarModule } from 'app/layout/components/toolbar/toolbar.module';

import { HorizontalLayout1Component } from 'app/layout/horizontal/layout-1/layout-1.component';

@NgModule({
    imports: [
    MatSidenavModule,
    NavbarModule,
    ToolbarModule,
    HorizontalLayout1Component
],
    exports: [
        HorizontalLayout1Component
    ]
})
export class HorizontalLayout1Module
{
}
